import $ from 'jquery';
import Cookies from 'js-cookie';
require('normalize.css/normalize.css');
require('../css/main.scss');
import 'regenerator-runtime/runtime';
import { db, getDoc, doc, auth, registerUser, getCompanyByName, createCompany, serverTimestamp, onAuthStateChanged, signOutUser } from '../js/firebaseConfig';
import { checkAuthAndRedirect } from '../js/redirect.js';

// ==========================================
// FIREBASE INDEX AUTO-OPENER
// Détecte automatiquement les erreurs d'index Firebase manquants
// et ouvre le lien de création dans un nouvel onglet
// ==========================================

(function() {
  if (window.__FIREBASE_INDEX_AUTO_OPENER__) {
    return;
  }
  window.__FIREBASE_INDEX_AUTO_OPENER__ = {
    openedUrls: new Set()
  };
  // Fonction pour extraire l'URL de création d'index depuis le message d'erreur
  function extractIndexUrl(errorMessage) {
    const urlMatch = errorMessage.match(/https:\/\/console\.firebase\.google\.com\/[^\s]+/);
    return urlMatch ? urlMatch[0] : null;
  }

  // Fonction pour afficher une notification toast
  function showIndexNotification(url) {
    const toast = $(`
      <div class="firebase-index-toast" style="
        position: fixed;
        bottom: 20px;
        right: 20px;
        background: #ff5722;
        color: white;
        padding: 16px 24px;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        z-index: 99999;
        max-width: 400px;
        animation: slideIn 0.3s ease-out;
      ">
        <div style="display: flex; align-items: start; gap: 12px;">
          <div style="font-size: 24px;">🔍</div>
          <div style="flex: 1;">
            <strong style="display: block; margin-bottom: 4px;">Index Firebase manquant détecté !</strong>
            <p style="margin: 0; font-size: 14px; opacity: 0.9;">
              Un nouvel onglet va s'ouvrir pour créer l'index automatiquement.
            </p>
          </div>
          <button class="close-toast" style="
            background: none;
            border: none;
            color: white;
            font-size: 20px;
            cursor: pointer;
            padding: 0;
            margin-left: 8px;
          ">×</button>
        </div>
      </div>
      <style>
        @keyframes slideIn {
          from {
            transform: translateX(400px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
        #webpack-dev-server-client-overlay, .webpack-dev-server-client-overlay { display: none !important; }
      </style>
    `);
    
    $('body').append(toast);
    
    // Fermer le toast au clic sur le bouton
    toast.find('.close-toast').on('click', function() {
      toast.fadeOut(200, function() {
        $(this).remove();
      });
    });
    
    // Auto-fermeture après 8 secondes
    setTimeout(() => {
      if (toast.length) {
        toast.fadeOut(200, function() {
          $(this).remove();
        });
      }
    }, 8000);
  }

  // Fonction pour gérer l'ouverture du lien d'index
  function handleIndexError(errorMessage) {
    const indexUrl = extractIndexUrl(errorMessage);
    
    if (indexUrl) {
      if (window.__FIREBASE_INDEX_AUTO_OPENER__.openedUrls.has(indexUrl)) {
        return true;
      }
      window.__FIREBASE_INDEX_AUTO_OPENER__.openedUrls.add(indexUrl);

      // Afficher la notification
      showIndexNotification(indexUrl);
      
      // Ouvrir le lien dans un nouvel onglet
      window.open(indexUrl, '_blank');
      
      return true;
    }
    
    return false;
  }

  // Intercepter console.error
  const originalConsoleError = console.error;
  console.error = function(...args) {
    // Appeler la fonction originale
    originalConsoleError.apply(console, args);
    
    // Vérifier si c'est une erreur d'index Firebase
    const errorString = args.map(arg => {
      if (typeof arg === 'string') return arg;
      if (arg && typeof arg === 'object' && arg.message) return arg.message;
      if (arg && typeof arg === 'object' && arg.toString) return arg.toString();
      return '';
    }).join(' ');
    
    if (errorString.includes('The query requires an index') && 
        errorString.includes('console.firebase.google.com')) {
      handleIndexError(errorString);
    }
  };

  // Intercepter les erreurs non capturées
  window.addEventListener('error', function(event) {
    const errorMessage = event.message || event.error?.message || '';
    
    if (errorMessage.includes('The query requires an index') && 
        errorMessage.includes('console.firebase.google.com')) {
      handleIndexError(errorMessage);
      event.preventDefault();
    }
  });

  // Intercepter les rejets de promesses non capturés
  window.addEventListener('unhandledrejection', function(event) {
    const errorMessage = event.reason?.message || event.reason?.toString() || '';
    
    if (errorMessage.includes('The query requires an index') && 
        errorMessage.includes('console.firebase.google.com')) {
      handleIndexError(errorMessage);
      
      // Ne pas afficher l'erreur dans la console (déjà géré)
      event.preventDefault();
    }
  });

})();

// ==========================================
// GESTION D'ERREURS GLOBALE - Protection contre les scripts bloqués
// ==========================================
(function() {
  // Intercepter les erreurs de scripts bloqués
  window.addEventListener('error', function(event) {
    // Ignorer les erreurs de scripts HubSpot bloqués
    if (event.filename && (
      event.filename.includes('hs-scripts.com') ||
      event.filename.includes('hs-analytics.net') ||
      event.filename.includes('hsforms.com') ||
      event.message.includes('ERR_BLOCKED_BY_CLIENT')
    )) {
      console.warn('⚠️ Script externe bloqué:', event.filename || event.message);
      event.preventDefault();
      return false;
    }
  });

  // Intercepter les erreurs de réseau
  window.addEventListener('unhandledrejection', function(event) {
    if (event.reason && (
      event.reason.message && event.reason.message.includes('ERR_BLOCKED_BY_CLIENT')
    )) {
      console.warn('⚠️ Requête réseau bloquée:', event.reason);
      event.preventDefault();
      return false;
    }
  });
})();

// ==========================================

$(document).ready(function() {

  //console.log('Espace Demo');

});